"use strict";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  transition: transform 1500ms ease-in-out;\n  animation: ", " 0.7s ease-in-out infinite;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _box = _interopRequireDefault(require("@waglabs/box"));

var _flex = _interopRequireDefault(require("@waglabs/flex"));

var _LoadingBone = _interopRequireDefault(require("./assets/LoadingBone"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var spin = _styledComponents.keyframes(_templateObject());

var Spin = (0, _styledComponents.default)(_box.default)(_templateObject2(), spin);

var LoadingBoneSpinner = function LoadingBoneSpinner() {
  return _react.default.createElement(_flex.default, {
    alignSelf: "center",
    bg: "rgba(0, 0, 0, 0.8)",
    borderRadius: "15px",
    p: "15px",
    px: "20px"
  }, _react.default.createElement(Spin, null, _react.default.createElement(_LoadingBone.default, {
    height: "60px",
    width: "60px"
  })));
};

var _default = LoadingBoneSpinner;
exports.default = _default;